import React, { Component } from 'react'
import { DefaultContainer, MinimapContainer, PrintPreviewViewportContainer } from 'components'
import { Rectangle } from 'helpers/math'
import './Minimap/minimap.css'
import PropTypes from 'prop-types'

export class Viewport extends Component {

    static propTypes = {
        isPrintPreviewOpened: PropTypes.bool.isRequired,
        isSourceLoaded: PropTypes.func.isRequired,
        isMinimapDisplayed: PropTypes.bool.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.state = {
            minimap: null,
        }

        this.setMinimapRef = this.setMinimapRef.bind(this)
    }

    setMinimapRef(node)
    {
        this.setState({
            minimap: node
        })
    }

    render() {
        const { isPrintPreviewOpened, isMinimapDisplayed, isSourceLoaded } = this.props
        const { minimap } = this.state

        let viewport = <DefaultContainer id={"default"} frame={this.props.frame} />

        if(isPrintPreviewOpened)
        {
            viewport = <PrintPreviewViewportContainer id={"preview"} frame={this.props.frame} />
        }

        return (
            <React.Fragment>
                {viewport}
                {isMinimapDisplayed && isSourceLoaded(viewport.props.id) &&
                    <div
                        className="minimap-container"
                        ref={this.setMinimapRef}
                    >
                        {
                            minimap &&
                            <MinimapContainer id="minimap" parentId={viewport.props.id} frame={Rectangle.createFromElement(minimap)} />
                        }
                    </div>
                }
            </React.Fragment>
        )
    }
}
